'use client';
import { Typography } from '@curology/ui-components-web/react/Typography';
import clsx from 'clsx';
import React from 'react';

import { type Estimate } from '@/services/resubscriptionService/types';

import { centsToDollarsAndCents } from '../utils/helpers';

const PriceSummary = ({ estimate }: { estimate: Estimate }) => (
  <div className="cur-p-4">
    <li className="cur-flex cur-justify-between cur-mb-2">
      <Typography>Subtotal</Typography>
      <Typography>
        <span className="cur-font-bold">
          {centsToDollarsAndCents(estimate.originalAmount.amount)}
        </span>
      </Typography>
    </li>
    <li className="cur-flex cur-justify-between cur-mb-2">
      <Typography>Shipping</Typography>
      <Typography>
        <span className="cur-font-bold">FREE</span>
      </Typography>
    </li>
    {estimate.tax.amount > 0 && (
      <li className="cur-flex cur-justify-between cur-mb-2">
        <Typography>Estimated Tax</Typography>
        <Typography>
          <span className="cur-font-bold">
            {centsToDollarsAndCents(estimate.tax.amount)}
          </span>
        </Typography>
      </li>
    )}
    <div className={clsx(estimate.adjustments.length > 0 ? 'cur-pt-4' : '')}>
      {estimate.adjustments.map((adjustment, key) => (
        <li className="cur-flex" key={key}>
          <Typography>
            <span className="cur-font-bold">{adjustment.label}</span> applied (
            {centsToDollarsAndCents(adjustment.amount.amount)})
          </Typography>
        </li>
      ))}
    </div>
    <div className="cur-bg-surface-highlight cur-mt-4 cur-p-4">
      <div className="cur-flex cur-justify-between">
        <Typography>Total</Typography>
        <Typography weight="bold">
          <span className="cur-font-bold">
            {centsToDollarsAndCents(estimate.total.amount)}
          </span>
          {estimate.adjustmentAmount.amount !== 0 && (
            <span className="cur-text-disabled">
              {' '}
              <span className="cur-line-through cur-font-normal">
                {centsToDollarsAndCents(
                  estimate.originalAmount.amount + estimate.tax.amount,
                )}
              </span>
            </span>
          )}
        </Typography>
      </div>
    </div>
  </div>
);

export default PriceSummary;
